import React, { useEffect, useRef, useState } from "react";
import Search from "../../../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Form, Select, Table } from "antd";
import svg27 from "../../../../../../assets/svg/svg27.svg";
import svg12 from "../../../../../../assets/svg/svg12.svg";
import svg13 from "../../../../../../assets/svg/svg13.svg";
import svg29 from "../../../../../../assets/svg/svg29.svg";
import CardLoading from "../../../../../../components/CardLoading";
import { Link, useNavigate } from "react-router-dom";
import { fetchData } from "../../../../../../features/fetch/fetchSlice";
import { formatText, numberWithCommas } from "../../../../../../utils";
import moment from "moment";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import DonorAdd from "./modal/DonorAdd";
import { cashConverter } from "../../../../../../utils";
import ConfirmModal from "../../../../../../components/ConfirmModal";
import toast from "react-hot-toast";
import { save } from "../../../../../../features/save/saveSlice";

function DonorTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const formRef = useRef(null);
  const url = "api/v2/mainProject/donor/get";
  const urlSymbol = "api/v2/moneySymbol/get";
  const urlDonor = "api/v2/irrPart/fetch";
  const { loading, data, count, activeObjOngoingProject } = useSelector(
    (state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjOngoingProject: state.obj.activeObj["ongoingProject"],
    }),
  );
  const { refetchKey } = useSelector((state) => state.global);

  const { open, handleCancel, handleOpen } = useModalToggle();

  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        pdProjectId: activeObjOngoingProject?.projectId,
        pdDonorTypeName: e.target.value == "" ? null : e.target.value,
      }),
    );
  };
  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/mainProject/donor/delete",
        pdId: prodd?.pdId,
      }),
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const handleEdit = async () => {
    await handleOpen();
  };
  const handleAdd = async () => {
    await setProdd();
    await handleOpen();
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Funder",
      dataIndex: "pdIpName",
      sorter: (a, b) => a.pdIpName.localeCompare(b.pdIpName),
    },
    {
      title: "Currency",
      dataIndex: "pdCurrencyName",
      sorter: (a, b) => a.pdCurrencyName.localeCompare(b.pdCurrencyName),
    },
    {
      title: "Funding Type",
      dataIndex: "pdFundingType",
      render: (item) => {
        return <div>{formatText(item)}</div>;
      },
      sorter: (a, b) => a.pdFundingType.localeCompare(b.pdFundingType),
    },
    {
      title: "Grant Amount",
      dataIndex: "pdGrantAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.pdGrantAmount.localeCompare(b.pdGrantAmount),
    },
    {
      title: "Loan Amount",
      dataIndex: "pdLoanAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.pdLoanAmount.localeCompare(b.pdLoanAmount),
    },
    {
      title: "Exchequer Amount",
      dataIndex: "pdExchequerAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.pdExchequerAmount.localeCompare(b.pdExchequerAmount),
    },
    {
      title: "Farmer Amount",
      dataIndex: "pdFarmerAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.pdFarmerAmount.localeCompare(b.pdFarmerAmount),
    },
    {
      title: "Convertion Rate",
      dataIndex: "pdConversionRate",
      sorter: (a, b) => a.pdConversionRate.localeCompare(b.pdConversionRate),
    },
    {
      title: "Amount",
      dataIndex: "pdAmount",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.pdAmount.localeCompare(b.pdAmount),
    },
    {
      title: "Converted Amount",
      dataIndex: "pdConvertedAmount",
      render: (item) => {
        return <div>{cashConverter(item)}</div>;
      },
      sorter: (a, b) => a.pdConvertedAmount.localeCompare(b.pdConvertedAmount),
    },

    {
      title: "Start Date",
      dataIndex: "pdStartDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.pdStartDate).valueOf() - moment(b.pdStartDate).valueOf(),
    },

    ...(!["COMPLETED", "STALLED"]?.includes(
      activeObjOngoingProject?.projectStatus,
    )
      ? [
          {
            title: "Actions",
            render: (item) => (
              <>
                <Dropdown
                  overlayStyle={{
                    width: "250px",
                  }}
                  trigger={"click"}
                  menu={{ items: settingItems }}
                  placement="bottom"
                >
                  <button onClick={() => setProdd(item)}>
                    <img src={svg27} alt="svg27" />
                  </button>
                </Dropdown>
              </>
            ),
          },
        ]
      : []),
  ];

  const onFinish = () => {};

  async function fetchDonorData() {
    await dispatch(
      fetchData({
        url: urlDonor,
        limit: null,
        start: 0,
        mipIrrigationPartnerType: "DONOR",
      }),
    );
  }

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pdProjectId: activeObjOngoingProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      }),
    );
  }

  useEffect(() => {
    if (refetchKey == 2) {
      fetchTableData();
      fetchDonorData();
      dispatch(
        fetchData({
          url: urlSymbol,
          limit: null,
          start: 0,
        }),
      );
    }
  }, [refetchKey]);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="flex flex-col w-full  flex-1">
      <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="form-add-h">Project Funders</div>
        <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
          <div className="lg:w-[16.125rem] w-full  ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search"}
            />
          </div>
          {activeObjOngoingProject?.projectStatus === "COMPLETED" ||
          activeObjOngoingProject?.projectStatus === "STALLED" ? null : (
            <div className="w-[150px]">
              <button onClick={() => handleAdd()} className="cstm-btn-2">
                <img src={svg29} alt="svg29" />{" "}
                <span className="ml-1">Add Funder</span>
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="max-w-full w-full overflow-x-auto">
        <Table
          rowSelection={false}
          className="mt-[1.75rem] w-full"
          scroll={{
            x: "auto",
          }}
          rowKey={(record) => record?.pdId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          summary={() => {
            const totalGrantAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdGrantAmount || 0),
              0,
            );
            const totalLoanAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdLoanAmount || 0),
              0,
            );
            const totalExchequerAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdExchequerAmount || 0),
              0,
            );
            const totalFarmerAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdFarmerAmount || 0),
              0,
            );
            const totalAmount = data?.reduce(
              (sum, item) => sum + Number(item?.pdAmount || 0),
              0,
            );
            const hasActions = !["COMPLETED", "STALLED"]?.includes(
              activeObjOngoingProject?.projectStatus,
            );
            return (
              <Table.Summary.Row className="bg-[#F1F3F5] font-[600]">
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={2}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                  {numberWithCommas(totalGrantAmount)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                  {numberWithCommas(totalLoanAmount)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                  {numberWithCommas(totalExchequerAmount)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7}>
                  {numberWithCommas(totalFarmerAmount)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}></Table.Summary.Cell>
                <Table.Summary.Cell index={9}>
                  {numberWithCommas(totalAmount)}
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10}></Table.Summary.Cell>
                <Table.Summary.Cell index={11}></Table.Summary.Cell>
                {hasActions && (
                  <Table.Summary.Cell index={12}></Table.Summary.Cell>
                )}
              </Table.Summary.Row>
            );
          }}
        />
      </div>

      <DonorAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </div>
  );
}

export default DonorTable;
